import en_GB from "./en-GB";

export default {
  "en-GB": en_GB,
};
